import { useTranslation } from 'react-i18next'
import { ProducerLocationProps } from 'components/producer-location/types'
import classNames from 'classnames'
import styles from './ProducerLocation.module.scss'
import { energyToIconName } from 'utils/mapping'
import { Tag } from '@boltenergy-be/design-system'

const ProducerLocation = ({ energyType, energyName, location, boxed, className }: ProducerLocationProps) => {
  // i18n
  const { t } = useTranslation('producer')

  return (
    <div className={classNames(styles.wrapper, { [styles.boxed]: boxed }, className)}>
      <Tag size="small" icon={energyToIconName(energyType)} type="positive">
        {energyName || t(($) => $.energyType[energyType])}
      </Tag>
      {location && (
        <Tag size="small" icon="location" type="positive">
          {location}
        </Tag>
      )}
    </div>
  )
}

export default ProducerLocation
